export default __webpack_public_path__ + "static/media/avi-shushan.07aa1750.png";